import { useEffect, useState } from 'react';

import videocallshopApi from '../../apis/videocallshop';

const PAGE_SIZE = 50; // el máximo que acepta la API (helpers/catalog.js)
const MAX_PRODUCTS = 300; // tope de seguridad para el carrusel

// Todo el catálogo visible de una tienda, pedido una sola vez al entrar al
// vivo o a la llamada (el poll sólo trae el producto pineado). Si falla,
// queda vacío y el carrusel no se muestra: la llamada sigue igual.
const useFullCatalog = (storeId) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!storeId) return undefined;
        let cancelled = false;
        setItems([]);

        (async () => {
            const all = [];
            let offset = 0;
            try {
                while (offset !== null && all.length < MAX_PRODUCTS) {
                    const {
                        data,
                    } = await videocallshopApi.get(
                        `/stores/${storeId}/catalog`,
                        { params: { limit: PAGE_SIZE, offset } }
                    );
                    if (cancelled) return;
                    const page = data.data || {};
                    all.push(...(page.items || []));
                    offset =
                        page.hasMore && page.nextOffset != null
                            ? page.nextOffset
                            : null;
                }
            } catch (err) {
                console.error('Error al cargar el catálogo del carrusel:', err);
            }
            if (!cancelled) setItems(all);
        })();

        return () => {
            cancelled = true;
        };
    }, [storeId]);

    return items;
};

export default useFullCatalog;
